import { useI18n } from './i18n';

// Trade grades: how well a trade was executed, A+ (best) to B- (weakest).
export const GRADES = ['A+', 'A', 'A-', 'B+', 'B', 'B-'];

const SCORE = { 'A+': 6, A: 5, 'A-': 4, 'B+': 3, B: 2, 'B-': 1 };

export function gradeScore(grade) {
  return SCORE[grade] || null;
}

// The A grades are the trades worth repeating.
export function isTopGrade(grade) {
  return grade === 'A+' || grade === 'A';
}

// The average of some grades, rounded to the nearest grade.
export function averageGrade(grades) {
  const scores = grades.map(gradeScore).filter(Boolean);
  if (!scores.length) return null;
  const avg = scores.reduce((a, b) => a + b, 0) / scores.length;
  return GRADES[GRADES.length - Math.round(avg)];
}

function gradeTone(grade) {
  return grade && grade.startsWith('A') ? 'grade-a' : 'grade-b';
}

export function GradeBadge({ grade }) {
  const { t } = useI18n();
  if (!grade) return null;
  return <span className={`grade-badge ${gradeTone(grade)}`} title={t('Graded {grade}', { grade })}>{grade}</span>;
}

// A row of grade buttons; clicking the selected grade clears it.
export function GradePicker({ value, onChange }) {
  const { t } = useI18n();
  return (
    <div className="grade-picker" role="radiogroup" aria-label={t('Grade this trade')}>
      {GRADES.map((g) => (
        <button key={g} type="button" role="radio" aria-checked={value === g}
          className={`grade-button ${gradeTone(g)}${value === g ? ' selected' : ''}`}
          onClick={() => onChange(value === g ? '' : g)}>
          {g}
        </button>
      ))}
    </div>
  );
}
